export default __webpack_public_path__ + "static/improve-quality-of-life-accomplishment-2a-d277a019b783877306450249819abbb6.webp";